import { render, staticRenderFns } from "./AbkCurrentOffers.vue?vue&type=template&id=1a1f0fec&scoped=true&"
import script from "./AbkCurrentOffers.vue?vue&type=script&lang=js&"
export * from "./AbkCurrentOffers.vue?vue&type=script&lang=js&"
import style0 from "./AbkCurrentOffers.vue?vue&type=style&index=0&id=1a1f0fec&lang=scss&scoped=true&"
import style1 from "./AbkCurrentOffers.vue?vue&type=style&index=1&id=1a1f0fec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1f0fec",
  null
  
)

export default component.exports